/**
 * @module api-scm:assemblyAndDisassemblyList.js
 */

import service from '@/service'

/**
 * @param {{
 * productCode:string,
 * supplier:string}} params
 * @description  查询列表
 */
export function getList(data) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/getList',
    method: 'post',
    data
  })
}

/**
 * 创建
 * @param {object} data
 * @returns {object}
 */
export function create(data) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/save',
    method: 'post',
    data
  })
}

/**
 * 更新
 * @param {object} data
 * @returns {object}
 */
export function update(data) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/update',
    method: 'post',
    data
  })
}
/**
 *  提交
 * @param {Array<string|number>} ids
 */

export function submit(ids) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/submit',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 详情
 * @param {number} id
 * @returns {any}
 */
export function info(id) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/info',
    method: 'get',
    params: { id },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * @param {{ids:string}} params
 * @description 删除
 */
export function remove(data) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/delete',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 根据条件查询详情
 * @param {object} data
 * @returns {object}
 */
export function queryDetail(data) {
  return service['api-web']({
    url: '/public/getAssemblyDisassemblyRelationDetail',
    method: 'post',
    data
  })
}

/**
 * 模糊查询未禁用的关系编码
 * @param {object} params
 * @returns {object}
 */
export function getRelationCodeList(params) {
  return service['api-web']({
    url: '/public/getRelationCodeList',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

/**
 * 根据库位代码获取批次号和可用量
 * @param {object} params
 * @returns {object}
 */
export function getByInventoryCode(data) {
  return service['api-scm']({
    url: '/public/inventory/getByInventoryCode',
    method: 'post',
    data
  })
}

// 手动对接
export function manualDock(ids) {
  return service['api-scm']({
    url: '/scm/warehouse/assemblyAndDisassemblyList/manualDockingAssemblyToKingDee',
    method: 'post',
    data: { ids },
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
